import { ShieldXIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { ErrorPage } from '@/modules/errors/components/ErrorPage';
import { Button } from '@/modules/ui/components/button/Button';

export const PermissionDenied = () => {
  return (
    <ErrorPage
      icon={<ShieldXIcon className="text-muted-foreground mb-4 h-16 w-16" />}
      title="Access Denied"
      message={
        <>
          You don&apos;t have permission to access this page. <br /> If you
          believe this is a mistake, please contact your administrator.
        </>
      }
      actions={
        <Button asChild>
          <Link to="/">Go to Dashboard</Link>
        </Button>
      }
    />
  );
};
